import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { AdresIcon } from "../../atoms/icons/AdresIcon";
import { useTranslation } from 'react-i18next';

// All the incoming values
interface IProps {
    value?: string | null;
    street?: string | null;
    houseNumber?: string | null;
    city?: string | null;
    postalCode?: string | null;
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & Omit<IDefaultViewProps<string | null>, 'value'>;
export const Adres = (props: AllProps) => {
    const { t: tDatatypes } = useTranslation('datatypes');
    
    const formatAddress = () => {
        // If a simple value is provided, use that
        if (props.value) {
            return props.value;
        }
        
        const parts: string[] = [];
        
        // Street and house number
        if (props.street && props.houseNumber) {
            parts.push(`${props.street} ${props.houseNumber}`);
        } else if (props.street) {
            parts.push(props.street);
        }
        
        // Postal code and city
        if (props.postalCode && props.city) {
            parts.push(`${props.postalCode} ${props.city}`);
        } else if (props.city) {
            parts.push(props.city);
        }
        
        return parts.length > 0 ? parts.join(', ') : '-';
    };
    
    const label = props.label || tDatatypes('adresLabel') || "Adres";
    return (<Caption loading={props.loading} caption={label} icon={<AdresIcon />}>
        {formatAddress()}
    </Caption>)
}
